import { render, staticRenderFns } from "./WizardStepsItem.vue?vue&type=template&id=58472adb&"
import script from "./WizardStepsItem.vue?vue&type=script&lang=js&"
export * from "./WizardStepsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports